// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__Tvt-o","ranges":"BmiRanges_ranges__Mw0xl"};